import axios from "axios";
const GlobalService = require("../react/global_services");

export const getLaborAnalyticsDashboardURL = function (postParams: any) {
    return axios.post(GlobalService.getOutboundDashboardUrl(), postParams).then((response: any) => {
        return response.data;
    });
};
